import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

import { setupStore } from '../auth/setup';
import errorControlMiddleware from '../note/errorControl/middleware';
import fingerMiddleware from '../note/finger/middleware';
import { createSagaMiddleware } from '../redux-saga';
import persistent from './persistent';
import { reducer } from './reducer';
import { storeRootSaga } from './saga';
 
export class Store {
    public static create(preloadedState?: any) {
        const sagaMiddleware = createSagaMiddleware();
        // tslint:disable-next-line
        // const reduxDevTools = (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__();
        // tslint:disable-next-line
        const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        const createStoreWithMiddleware = composeEnhancers(applyMiddleware(fingerMiddleware, sagaMiddleware, errorControlMiddleware), persistent())(createStore);
        const store = createStoreWithMiddleware(combineReducers<any>(reducer as any), preloadedState);
        sagaMiddleware.run(storeRootSaga as any);
        setupStore(store);
        return store;
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/store/Store.tsx